// extracted by css-extract-rspack-plugin
var _1 = "src-pages-Fallbacks-Maintenance-Maintenance-module__buttons-ePOPq2";
var _2 = "src-pages-Fallbacks-Maintenance-Maintenance-module__content-rNpXa4";
var _3 = "src-pages-Fallbacks-Maintenance-Maintenance-module__danger-hMvbIb";
var _4 = "src-pages-Fallbacks-Maintenance-Maintenance-module__hammer-I7boT4";
var _5 = "src-pages-Fallbacks-Maintenance-Maintenance-module__inner-glow-wwRKC0";
var _6 = "src-pages-Fallbacks-Maintenance-Maintenance-module__inner-glow-wwRKC0";
var _7 = "src-pages-Fallbacks-Maintenance-Maintenance-module__maintenancePage-YdWfOy";
var _8 = "src-pages-Fallbacks-Maintenance-Maintenance-module__maintenancePageWrapper-rHe9LH";
var _9 = "src-pages-Fallbacks-Maintenance-Maintenance-module__outer-glow-mgOzpQ";
var _a = "src-pages-Fallbacks-Maintenance-Maintenance-module__outer-glow-mgOzpQ";
var _b = "src-pages-Fallbacks-Maintenance-Maintenance-module__text-rDgp4V";
export { _1 as "buttons", _2 as "content", _3 as "danger", _4 as "hammer", _5 as "inner-glow", _6 as "innerGlow", _7 as "maintenancePage", _8 as "maintenancePageWrapper", _9 as "outer-glow", _a as "outerGlow", _b as "text" }

    if(module.hot) {
      (function() {
        var localsJsonString = "{\"buttons\":\"src-pages-Fallbacks-Maintenance-Maintenance-module__buttons-ePOPq2\",\"content\":\"src-pages-Fallbacks-Maintenance-Maintenance-module__content-rNpXa4\",\"danger\":\"src-pages-Fallbacks-Maintenance-Maintenance-module__danger-hMvbIb\",\"hammer\":\"src-pages-Fallbacks-Maintenance-Maintenance-module__hammer-I7boT4\",\"inner-glow\":\"src-pages-Fallbacks-Maintenance-Maintenance-module__inner-glow-wwRKC0\",\"innerGlow\":\"src-pages-Fallbacks-Maintenance-Maintenance-module__inner-glow-wwRKC0\",\"maintenancePage\":\"src-pages-Fallbacks-Maintenance-Maintenance-module__maintenancePage-YdWfOy\",\"maintenancePageWrapper\":\"src-pages-Fallbacks-Maintenance-Maintenance-module__maintenancePageWrapper-rHe9LH\",\"outer-glow\":\"src-pages-Fallbacks-Maintenance-Maintenance-module__outer-glow-mgOzpQ\",\"outerGlow\":\"src-pages-Fallbacks-Maintenance-Maintenance-module__outer-glow-mgOzpQ\",\"text\":\"src-pages-Fallbacks-Maintenance-Maintenance-module__text-rDgp4V\"}";
        // 1752373455370
        var cssReload = require("../../../../node_modules/.pnpm/@rspack+core@1.4.6_@swc+helpers@0.5.17/node_modules/@rspack/core/dist/cssExtractHmr.js").cssReload(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  